/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.conglomerateMemberships.internal

import features.conglomerateMemberships.models.Businesses
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class ConglomerateMembershipsServiceImpl : ConglomerateMembershipsService {

    private val conglomerateMembershipsRequest = ConglomerateMembershipsRequest()

    override suspend fun getConglomerateMemberships(
        overrideHeaders : Map<String, String>?,
    ): Result<Businesses> {
        return conglomerateMembershipsRequest.getConglomerateMemberships(
            overrideHeaders = overrideHeaders,
        ).toModel()
    }
}
